export default "__VITE_ASSET__B_KKjg7L__"